(function(){
    'use strict';
    
    var my_research_exists = !!document.querySelector('.my-research__wrapper');

    if (my_research_exists) {

        var all_my_research = document.querySelectorAll('.my-research__wrapper');

        for (let i = 0; i < all_my_research.length; i++) {
            const my_research = all_my_research[i];

            // Hack so I don't need to make a new component, should be able to be done in react with a prop passed through
            my_research.querySelector('.i-want-links__title').innerHTML = 'Quick access';
            
        }

    }
    
}());
